import isValid from "date-fns/is_valid";
import { areAnyFieldsPristine, areFieldsPristine, areFieldsTouched, isPasswordValid, validateLengthAndContent } from "../FieldValidators";
import { getSecurePasswordString } from "@limitless/common/utils";
export const validateFirstName = (firstNameField, isMandatory) => {
  const result = validateLengthAndContent(firstNameField, {
    label: "First name",
    dataKey: "firstName",
    minLength: 2,
    regexType: "specialCharsNoNumbers",
    checkEmpty: isMandatory
  });
  return result;
};
export const validateLastName = (lastNameField, isMandatory) => {
  const result = validateLengthAndContent(lastNameField, {
    label: "Last name",
    dataKey: "lastName",
    minLength: 2,
    regexType: "specialCharsNoNumbers",
    checkEmpty: isMandatory
  });
  return result;
};

/**
 * Validates the user inputs for the About form
 *
 * @param {object} fields
 */
export const validateAboutForm = fields => {
  let fieldErrors = {};
  if (areFieldsPristine(fields)) {
    return {
      fieldErrors,
      isFormInvalid: true
    };
  }
  const {
    socialSecurityNo,
    firstName,
    lastName,
    dob
  } = fields;
  fieldErrors = {
    ...fieldErrors,
    ...validateFirstName(firstName, true)
  };
  fieldErrors = {
    ...fieldErrors,
    ...validateLastName(lastName, true)
  };
  if (!dob.pristine && dob.value !== 0) {
    if (!isValid(new Date(dob.formattedValue))) {
      fieldErrors.dob = "Date of Birth should be yyyy-mm-dd";
    }
  }
  if (socialSecurityNo.value && socialSecurityNo.isSocialEnabled && socialSecurityNo.socialSecurityMaskLen !== socialSecurityNo.value.replace(/[^\w\s]/gi, "").length) {
    fieldErrors.socialSecurityNo = "Please enter correct social security number";
  }
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || !areFieldsTouched(fields);
  return {
    fieldErrors,
    isFormInvalid
  };
};
export const validateProfileForm = (fields, isPasswordChanged = false) => {
  const PASSWORD_VALIDATION_MESSAGE = getSecurePasswordString();
  let profileFieldErrors = {};
  if (areFieldsPristine(fields)) {
    return {
      profileFieldErrors,
      isFormInvalid: true
    };
  }
  const {
    firstName,
    lastName,
    currentPassword,
    newPassword
  } = fields;
  let touchedFeilds = !areFieldsTouched(fields);
  profileFieldErrors = {
    ...profileFieldErrors,
    ...validateFirstName(firstName, true)
  };
  profileFieldErrors = {
    ...profileFieldErrors,
    ...validateLastName(lastName, true)
  };

  //disable for temporary purpose because if it's unable user can not change the password due to validation issue in current password
  // if (!currentPassword.pristine && !isPasswordValid(currentPassword.value)) {
  //     profileFieldErrors.currentPassword = PASSWORD_VALIDATION_MESSAGE;
  // }

  if (!newPassword.pristine && !isPasswordValid(newPassword.value)) {
    profileFieldErrors.newPassword = PASSWORD_VALIDATION_MESSAGE;
  }
  if (!currentPassword.pristine && !newPassword.pristine && currentPassword.value === newPassword.value) {
    profileFieldErrors.newPassword = "New password should not be the same as your current password";
  }

  // Only for password change
  if (isPasswordChanged) {
    touchedFeilds = areAnyFieldsPristine({
      currentPassword,
      newPassword
    });
  }
  const isFormInvalid = Object.keys(profileFieldErrors).length > 0 || touchedFeilds;
  return {
    profileFieldErrors,
    isFormInvalid
  };
};